//make sure the script runs only on collection page
if ($('.template-collection').length) {
	// global variables
	var configureMutation = { attributes: true, childList: true, characterData: true };
	var collectionHref = window.location.href.split('?')[0];

	collectionFilterDropdown();

	$('#snize-custom').each(function () {
		let target = this;
		let observer = new MutationObserver(function (mutations) {
			mutations.forEach(function (mutation) {
				additionalFilterElements();
				selectedFilters();
			});
		});

		observer.observe(target, configureMutation);
	});

	function additionalFilterElements() {
		//append safety info block
		if ($('body').find('.js-safety-info-html').length > 0) {
			const element7 = $('.snize-search-results-content > li:nth-child(7)');
			const safetyInfoHtml = $('body').find('.js-safety-info-html').html();

			if (element7.length) {
				$('.snize-search-results-content').prepend(safetyInfoHtml);
			}
		}

		// create and append container for selected filters
		const selectedFiltersContainer = $(
			`<div class="selected-filters-outer">
				<div class="list-selected-filters">
					<ul class="js-selected-filters"></ul>
				</div>
			</div>`
		);

		$(selectedFiltersContainer).insertAfter($('#snize-custom').find('.snize-horizontal-filters'));

		// append collection filter dropdown
		appendCollectionDropdown();

		// append clear all button to mobile filter modal
		let clearAllBtnMobile = $(
			`<a href="${collectionHref}" class="btn-clear-all js-selected-filters-clear">Clear All</a>`
		);

		$('body').find('#snize_filters_block_header').append(clearAllBtnMobile);

		// find reliable element inside the filter to watch for mutations in order to add additional functionalities
		const searchaniseProductsList = $('#snize-custom').find('.snize-search-results-content');

		$(searchaniseProductsList).each(function () {
			let target = this;
			let observer = new MutationObserver(function (mutations) {
				mutations.forEach(function (mutation) {
					selectedFilters();
				});
			});

			observer.observe(target, configureMutation);
		});
	}

	function selectedFilters() {
		let $selectedFilters = $('.js-selected-filters');
		let selectedValuesString = '';
		$selectedFilters.empty();

		appendCollectionDropdown();

		$('.snize-product-filters-checkbox').each(function () {
			const $input = $(this);

			// find only checked input
			if ($input.is(':checked')) {
				const inputVal = $input.val();

				if (selectedValuesString.indexOf(inputVal) === -1) {
					selectedValuesString += inputVal;

					const $selectedFilter = $(
						`<li><a href="#" class="js-selected-filter btn-selected-filter" data-ref-input="${inputVal}">${inputVal}<span></span></a></li>`
					);

					// create and append clear all filter button
					if ($('#snize-custom').find('.js-selected-filters-clear').length <= 0) {
						let clearAllElement = $(
							`<li><a href="${collectionHref}" class="btn-clear-all js-selected-filters-clear">Clear All</a></li>`
						);

						$selectedFilters.append(clearAllElement);
					}

					// start prepending selected filters
					$selectedFilters.prepend($selectedFilter);
				}
			}
		});
	}

	function appendCollectionDropdown() {
		if ($('body').find('.js-collection-filter-container').length > 0) {
			const collectionDropdownHtml = $('body').find('.js-collection-filter-container').html();
			const $lastFilter = $('.snize-horizontal-filters .snize-filters-dropdown:last-child');
			$(collectionDropdownHtml).insertAfter($lastFilter);
		}
	}

	function collectionFilterDropdown() {
		$(document).on('click', '.js-collection-dropdown .custom-filter__select', function () {
			$(this).parent().toggleClass('expanded');
		});
	}

	$(document).on('click', '.js-selected-filter', function (e) {
		e.preventDefault();
		const $this = $(this);
		const refInputVal = $this.data('ref-input');

		// find searchanise filter input
		const $refInput = $('#snize-custom').find(`input[value="${refInputVal}"]`);

		// trigger click on searchanise filter input
		$refInput.trigger('click');

		//clear container if no siblings left
		if ($this.siblings().length <= 0) {
			let $selectedFilters = $('.js-selected-filters');
			$selectedFilters.empty();
		}
	});
}
